<!--
  --
  -- 免許証情報設定 グループ
  --
  -->
<template>
  <c-form card-style
    v-model="valid"
    @submit="onSubmit"
  >
    <!-- Title -->
    <v-card-title>
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <slot/>

      <v-divider/>

      <v-radio-group
        label="情報メール"
        v-model="form.promotion"
        class="pt-0"
        dense hide-details
      >
        <v-radio label="配信を希望する" :value="1"/>
        <v-radio label="配信を希望しない" :value="0"/>
      </v-radio-group>
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <!-- Actions -->
    <v-card-actions>
      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </c-form>
</template>

<script>
import CForm from '@/components/CForm'
import CCardErrors from '@/components/CCardErrors'

import deepmerge from 'deepmerge'

export default {
  name: 'COptinGroup',
  components: {
    CForm,
    CCardErrors
  },
  props: {
    optins: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // フォームデータ
    form: {
      promotion: 1,
      notify: 1
    },

    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  created () {
    // optins プロパティから form にデータをコピーする
    this.form = deepmerge(this.optins, {})
  },
  methods: {
    /**
     * Submit ボタンが押された
     */
    onSubmit () {
      // エラー表示を消す
      this.errors = []

      // フォーム入力されたことを通知する
      this.running = true
      this.$emit('submit', this.form, (errors) => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    }
  }
}
</script>
